"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encryptScriptTags = void 0;
const encryptScriptTags = (source) => {
    if (!source) {
        return undefined;
    }
    return source
        .replace(/\<script\>/g, '[%{script}%]')
        .replace(/\<\/script\>/g, '[%{/script}%]')
        .replace(/\<script\s/g, '[%{script ');
};
exports.encryptScriptTags = encryptScriptTags;
//# sourceMappingURL=encryptScriptTags.js.map